import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Switch';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "switch"
    }}>{`Switch`}</h1>
    <p>{`Toggle switch button component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Switch } from '@rebass/forms'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Switch />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      